const REVIEW_HASH_RE = /\/add_review\/([a-f0-9]{32})\/?/i;

export const extractReviewHash = (reviewUrl: string | undefined): string | null => {
  if (!reviewUrl) {
    return null;
  }

  const match = reviewUrl.match(REVIEW_HASH_RE);

  return match?.[1] ?? null;
};

export const buildReviewUrlWithRate = (reviewUrl: string, rate: number): string => {
  const url = new URL(reviewUrl, window.location.origin);
  url.searchParams.set('rate', String(rate));

  return url.toString();
};
